import { Col, Row, Typography } from 'antd';
import React from 'react';
import { FormItem, Input, Select } from 'formik-antd';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { targetPlatformOptions } from '../../const/system';
import CountrySelector from '../CountrySelector';
import { countries } from '../../const/countries';
import { IntlMessages } from '@/components';
import { languages } from '../../const/languages';

const { Title } = Typography;

const NullableTargetingSettings = ({ setFieldValue, values, setFieldTouched, showTitle = true }) => {
  const intl = useIntl();

  return (
    <>
      {showTitle && (
        <Title className="hp-mb-24" level={4}>
          <IntlMessages id="ui-general-targets" />
        </Title>
      )}

      <Row gutter={16}>
        <Col span={12}>
          <FormItem label={intl.formatMessage({ id: 'ui-general-min-version' })} name="target.min_version">
            <Input
              name="target.min_version"
              placeholder={intl.formatMessage({ id: 'ui-general-targets-min-version-placeholder' })}
            />
          </FormItem>
        </Col>

        <Col span={12}>
          <FormItem label={intl.formatMessage({ id: 'ui-general-max-version' })} name="target.max_version">
            <Input
              name="target.max_version"
              placeholder={intl.formatMessage({ id: 'ui-general-targets-max-version-placeholder' })}
            />
          </FormItem>
        </Col>

        <Col span={24}>
          <FormItem
            label={intl.formatMessage({ id: 'ui-general-platform' })}
            name="target.platform"
            extra={intl.formatMessage({ id: 'ui-general-platform-extra' })}
          >
            <Select
              mode="multiple"
              maxTagCount="responsive"
              allowClear
              name="target.platform"
              options={targetPlatformOptions}
              placeholder={intl.formatMessage({ id: 'ui-general-choose-platform' })}
            />
          </FormItem>
        </Col>

        <Col span={24}>
          <FormItem
            label={intl.formatMessage({ id: 'ui-general-countries' })}
            name="target.countries"
            extra={intl.formatMessage({ id: 'ui-general-countries-extra' })}
          >
            <CountrySelector
              onSelectAll={async () => {
                await setFieldValue(
                  'target.countries',
                  countries.map((country) => country.value).sort((a, b) => a.localeCompare(b)),
                );
              }}
              isDisabledSelectAll={values?.target?.countries?.length === countries.length}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              name="target.countries"
              placeholder={intl.formatMessage({ id: 'ui-general-choose-countries' })}
            />
          </FormItem>
        </Col>
        <Col span={24}>
          <FormItem
            label={intl.formatMessage({ id: 'ui-general-languages' })}
            name="target.languages"
            extra={intl.formatMessage({ id: 'ui-general-languages-extra' })}
          >
            <Select
              mode="multiple"
              maxTagCount="responsive"
              allowClear
              name="target.languages"
              options={languages}
              placeholder={intl.formatMessage({ id: 'ui-general-choose-languages' })}
            />
          </FormItem>
        </Col>
      </Row>
    </>
  );
};

NullableTargetingSettings.propTypes = {
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  showTitle: PropTypes.bool,
};

export default NullableTargetingSettings;
